import * as api from '../../api';
import { pagingDataUtilities } from '../../common';

export const fetchListActions = api.fetchActions('closed', 'fetch-closed-messages');
export const pagingActions = pagingDataUtilities.pagingActions('closed', 'paging');

export const actionTypes = {
  ...fetchListActions.actionTypes,
  ...pagingActions.actionTypes
}

export function fetchList() {
  return (dispatch, getState) => {
    const state = getState();
    const { closed } = state;
    const { pagingData } = closed;
    const { currentPage, itemsPerPage } = pagingData || {};
    const params = {
      page: currentPage,
      perPage: itemsPerPage,
    };
    return dispatch(api.shouldExecute(['closed', 'listState'], api.getThunk(`/dashboard-messages/GetClosedDashboardMessages`, params, fetchListActions)));
  }
}

export const changePageNumber = (page) => pagingDataUtilities.changePage(page, pagingActions);
